module.exports = __webpack_public_path__ + "static/media/ccnl-08.09.2020-con-integrazione-23.09.2020.7fb49b0b.pdf";